import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useProgress } from "./ProgressContext.js";
import NowTimeBar from "../../../components/NowTimeBar/NowTimeBar.js";
import ProgressTable from "./ProgressTable.js";
import {
  currentDateTime, 
  formatRoundDate,
} from "../../../utils/dateUtils.js";
import { MESSAGES } from "../../../utils/messages.js";

const DistanceTable = () => {
  const { distanceParam } = useParams();
  const distance = distanceParam.replace("distance", "");
  const { schedules, loading, error, fetchSchedules } = useProgress();

  useEffect(() => {
    const current = currentDateTime();
    fetchSchedules(current, distance);
  }, [fetchSchedules, distance]);

  if (loading) {
    return <div>Loding...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!schedules || schedules.length === 0) {
    return <div>{MESSAGES.NO_DATA}</div>;
  }

  const date = formatRoundDate(currentDateTime());

  return (
    <>
      <NowTimeBar />
      <div className={distance === 145 ? "table-flex" : ""}>
        <ProgressTable
          event={distance}
          date={date}
          data={schedules}
        />
      </div>
    </>
  );
};
export default DistanceTable;
